import { render, staticRenderFns } from "./motoInfo.vue?vue&type=template&id=6d2de0b4&scoped=true&"
import script from "./motoInfo.vue?vue&type=script&lang=js&"
export * from "./motoInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2de0b4",
  null
  
)

export default component.exports